import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col sm:flex-row items-center sm:items-start gap-5 rounded-2xl border border-gray-100 bg-white shadow-sm p-6" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "text-2xl font-bold text-white" }
const _hoisted_4 = ["disabled", "aria-label"]
const _hoisted_5 = ["accept"]
const _hoisted_6 = { class: "flex flex-col items-center sm:items-start" }
const _hoisted_7 = { class: "text-2xl font-bold text-gray-900 text-center sm:text-left" }
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-gray-500 mb-3"
}
const _hoisted_9 = { class: "flex flex-wrap items-center justify-center sm:justify-start gap-2" }

import { computed, ref } from 'vue'
import { useToast } from 'vue-toastification'
import { mdiCameraOutline } from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'
import AvatarCropModal from '@/components/designSystem/modals/AvatarCropModal/Index.vue'
import { getInitials, resolveAvatarUrl } from '../../helpers/profile'

// Espelha a união de cores de LabelBadge.vue (não importável como type de um .vue).
type LabelBadgeColor = 'blue' | 'orange' | 'green' | 'yellow' | 'red' | 'gray'

const MAX_FILE_SIZE = 10 * 1024 * 1024

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileHeader',
  props: {
    name: {},
    email: {},
    avatarUrl: {},
    isActive: { type: Boolean },
    confirmed: { type: Boolean },
    uploading: { type: Boolean }
  },
  emits: ["uploadAvatar"],
  setup(__props: any, { emit }) {

const props = __props;





const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp']

const toast = useToast()

const fileInput = ref<HTMLInputElement | null>(null)
const selectedFile = ref<File | null>(null)
const isCropModalOpen = ref(false)

const avatarSrc = computed(() => resolveAvatarUrl(props.avatarUrl))
const initials = computed(() => getInitials(props.name))

const statusConfig = computed<{ label: string; color: LabelBadgeColor }>(() =>
  props.isActive ? { label: 'Ativo', color: 'green' } : { label: 'Inativo', color: 'gray' }
)

const triggerFileInput = () => fileInput.value?.click()

const onFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (!target.files || !target.files.length) return
  const file = target.files[0]
  // Reset antes da validacao para permitir re-selecionar o mesmo arquivo
  target.value = ''

  if (!ACCEPTED_TYPES.includes(file.type)) {
    toast.error('Formato inválido. Envie uma imagem JPEG, PNG ou WebP.')
    return
  }
  if (file.size > MAX_FILE_SIZE) {
    toast.error('A imagem excede o limite de 10MB.')
    return
  }

  selectedFile.value = file
  isCropModalOpen.value = true
}

const onCropModalClose = () => {
  isCropModalOpen.value = false
  selectedFile.value = null
}

const onCropped = (file: File) => {
  emit('uploadAvatar', file)
  onCropModalClose()
}

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_avatar, {
        color: "primary",
        size: "88"
      }, {
        default: _withCtx(() => [
          _createVNode(ProtectedAvatar, {
            src: avatarSrc.value,
            size: 88
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(initials.value), 1)
            ]),
            _: 1
          }, 8, ["src"])
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        type: "button",
        "data-testid": "profile-avatar-upload-button",
        disabled: _ctx.uploading,
        class: "absolute -bottom-1 -right-1 flex h-8 w-8 items-center justify-center rounded-full bg-primary text-white shadow-md ring-2 ring-white transition hover:bg-primary30 disabled:opacity-60",
        "aria-label": _ctx.uploading ? 'Enviando foto' : 'Alterar foto de perfil',
        onClick: triggerFileInput
      }, [
        (_ctx.uploading)
          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 0,
              indeterminate: "",
              size: "16",
              width: "2",
              color: "white"
            }))
          : (_openBlock(), _createBlock(_component_v_icon, {
              key: 1,
              size: "18"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(mdiCameraOutline)), 1)
              ]),
              _: 1
            }))
      ], 8, _hoisted_4),
      _createElementVNode("input", {
        ref_key: "fileInput",
        ref: fileInput,
        type: "file",
        class: "hidden",
        accept: ACCEPTED_TYPES.join(','),
        "data-testid": "profile-avatar-input",
        onChange: onFileChange
      }, null, 40, _hoisted_5),
      _createVNode(AvatarCropModal, {
        "modal-active": isCropModalOpen.value,
        file: selectedFile.value,
        onClose: onCropModalClose,
        onCropped: onCropped
      }, null, 8, ["modal-active", "file"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.name), 1),
      (_ctx.email)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.email), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(LabelBadge, {
          label: statusConfig.value.label,
          color: statusConfig.value.color,
          icon: null,
          size: "small"
        }, null, 8, ["label", "color"]),
        (_ctx.confirmed)
          ? (_openBlock(), _createBlock(LabelBadge, {
              key: 0,
              label: "E-mail verificado",
              color: "green",
              icon: null,
              size: "small"
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})